module.exports = __webpack_public_path__ + "static/media/guilherme.23f81bc0.jpg";